export const minusIconStyles = `ml-3`
